import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {useFormik} from 'formik'
import '../../../../_metronic/assets/sass/components/forgotPassword.scss'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import CommonLogin from '../../../../_metronic/helpers/components/login-components/CommonLogin'
import {useMutation} from '@apollo/client'
import {SENDFORGOTPASSWORDMAIL} from '../../../../utils/GraphQLAPI'
import successIcon from '../../../../_metronic/images/successIcon.svg'
import {navigateUser} from '../../../../utils/helper'

const MySwal = withReactContent(Swal)
const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 character is required')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
})

export const ForgotPassword = () => {
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState<string | undefined>()
  const [header, setHeader] = useState<string>()
  const navigate = useNavigate()
  const getUrlParams = useParams()
  const [roles, setRoles] = useState<any>()
  const [userRole, setUserRole] = useState<any>()
  useEffect(() => {
    const role: any = getUrlParams.adminUser
    navigateUser(role, setHeader, setUserRole, setRoles)
  }, [getUrlParams])

  const [sendForgotPasswordEmail] = useMutation(SENDFORGOTPASSWORDMAIL, {
    onCompleted: (data) => {
      if (data?.sendForgotPasswordMail === 'Email Sent Successfully!') {
        const options: any = {
          imageUrl: successIcon,
          imageWidth: 82,
          imageHeight: 82,
          imageAlt: 'Success image',
          showCancelButton: false,
          showConfirmButton: true,
          reverseButtons: true,
          confirmButtonText: 'Ok,got it!',
          confirmButtonColor: '#3E97FF',
          html: (
            <>
              <p className='text-gray-500 fw-normal fs-4'>
                We have sent a password reset link to your email <span style={{ color: "#3E97FF" }}>{email}</span>
              </p>
            </>
          ),
          customClass: {
            popup: 'card card-custom',
          },
        }
        MySwal.fire(options).then((value) => {
          navigate(`/${getUrlParams.adminUser}/login`)
        })
      }
    },
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
    },
  })

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values) => {
      setLoading(true)
      setEmail(values.email)
      // Creating a setTimeout method for alert confirmation
      sendForgotPasswordEmail({
        variables: {
          emailId: values.email.toLowerCase(),
          role: roles,
        },
      })
    },
  })

  return (
    <div
      className='d-flex flex-column flex-lg-row h-100 flex-column-fluid  vh-100'
      style={{
        backgroundImage: 'linear-gradient(rgb(35, 56, 119), rgb(12, 20, 43))',
        backgroundSize: 'cover',
      }}
    >
      <CommonLogin role={header} userRole={userRole} />
      <div className='d-flex flex-lg-row-fluid w-lg-50  order-1 order-lg-2 justify-content-center align-items-center '>
        <div className='card card-custom mt-5 pt-5 pb-5 px-4 py-4 ml-5  bg-light h-50 w-500px formWidth cardBox'>
          <form
            className='form  fv-plugins-bootstrap5 fv-plugins-framework bg-light '
            noValidate
            id='kt_login_password_reset_form'
            onSubmit={formik.handleSubmit}
          >
            <div className='text-center mb-10 pt-5'>
              <h1 className='text-dark fw-bolder mb-3'>Forgot Password ?</h1>
              <div className='text-gray-500 fw-semibold fs-6'>
                Enter your email to reset your password.
              </div>
            </div>
            <div className='fv-row mb-8 px-5 py-5'>
              <input
                type='email'
                placeholder=''
                autoComplete='off'
                {...formik.getFieldProps('email')}
                className={clsx(
                  'form-control bg-transparent',
                  {'is-invalid': formik.touched.email && formik.errors.email},
                  {'is-valid': formik.touched.email && !formik.errors.email}
                )}
              />
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.email}</span>
                  </div>
                </div>
              )}
            </div>
            <div className='d-flex flex-wrap justify-content-center pb-lg-5 '>
              <Link to={`/${getUrlParams.adminUser}/login`}>
                <button
                  type='button'
                  id='kt_login_password_reset_form_cancel_button'
                  className='btn btn-bg-secondary me-4'
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  Cancel
                </button>
              </Link>
              <button
                type='submit'
                id='kt_password_reset_submit'
                className='btn btn-primary me-4 mx-5'
              >
                <span className='indicator-label'>Submit</span>
                {loading && (
                  <span className='indicator-progress'>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
